import React, { useState } from "react";
import classnames from "classnames";

type SwitchOnChange = (enabled: boolean) => void;

const ToggleSwitch = ({
	enabled = false,
	theme = "default",
	className = null,
	onChange
}: {
enabled?: boolean;
theme?: string;
className?: string | null;
onChange?: SwitchOnChange;
}) => {
	const [isEnabled, setEnabled] = useState(enabled);

	const toggleSwitch = e => {
		e.persist();
		e.preventDefault();

		const newValue = !isEnabled;

		setEnabled(newValue);
		onChange(newValue);
	};

	const switchClasses = classnames(`switch switch--${theme}`, className);
	const togglerClasses = classnames("switch-toggle", `switch-toggle--${enabled ? "on" : "off"}`);

	return (
		<div className={switchClasses} onClick={toggleSwitch}>
			<div className={togglerClasses} />
		</div>
	);
};

export default ToggleSwitch;
